import { NgClass } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { OffcanvasDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/offcanvas.directive';
import { ToggleDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/toggle.directive';
import { FooterComponent } from '../../footer.component';
import { SideBarMenuComponent } from '../../nav/side-bar-menu.component';
import { ScrollTopComponent } from '../../scroll-top.component';
import { TopBarComponent } from '../../topbar.component';
import { Theme7BrandComponent } from './theme7-brand.component';

@Component({
    templateUrl: './theme7-layout.component.html',
    selector: 'theme7-layout',
    imports: [RouterLink, ToggleDirective, OffcanvasDirective, Theme7BrandComponent, SideBarMenuComponent, TopBarComponent, NgClass, RouterOutlet, FooterComponent, ScrollTopComponent]
})
export class Theme7LayoutComponent extends ThemesLayoutBaseComponent implements OnInit {

    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'kt-aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: {
            target: 'kt_aside_mobile_toggler',
            state: 'kt-header-mobile__toolbar-toggler--active'
        }
    };

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        _dateTimeService: DateTimeService,
        injector: Injector
    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit() {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    }
}
